module.exports = __webpack_public_path__ + "static/locales/vi.3wk6U_t.json";